// Escape value for Dropdown options
export const RequestNewProject = "RequestNewProject"; // RequestNewProject
export const ProjectNotSelected = "ProjectNotSelected"; // ProjectNotSelected
